/**
 * @type {BD_CFG}
 */
const CONFIG = {
  ajaxUrl: window.CFG?.ajaxUrl ?? "",
  nonce: window.CFG?.nonce ?? "",
  restURL: window.CFG?.restURL ?? "",
  currentURL: window.CFG?.currentURL ?? "",
  welcomeURL: window.CFG?.welcomeURL ?? "",
  GP: window.CFG?.GP ?? 0,
  hasSubmitRating: !!window.CFG?.hasSubmitRating,
  user: window.CFG?.user ?? {
    id: 0,
    avatar: "",
    nickname: "",
    email: "",
    userRole: [],
  },
  game_options: window.CFG?.game_options ?? {
    transition_between_building_block: "default-loader",
    go_to_next_when_time_runs_out: false,
    enable_submit_button_after_time_runs_out: false,
    modules: [],
    blindspot_show_after_building_block: 0,
    blindspot_close_after_building_block_post_game: 0,
    rating_type: "standard",
    building_block: {
      video: {
        video_disable_replay: false,
      },
      audio: {
        audio_disable_replay: false,
      },
    },
    story_mode: false,
  },
  siteSetup: window.CFG?.siteSetup ?? "default",
  sequences: window.CFG?.sequences ?? [],
  STTVersion: window.CFG?.STTVersion ?? false,
  teamconnector: window.CFG?.teamconnector ?? {
    id: 0,
    members: [],
    categories: [],
    timer: 0,
  },
  user_progress: window.CFG?.user_progress ?? {
    answer_variables: [],
    current_block_id: 0,
    current_block_type: false,
    history: [],
    team_code: false,
  },
  building_blocks: window.CFG?.building_blocks,
};

export default CONFIG;
